// vue-i18n
// 다국어 default Value 처리 함수
import i18n from "@/locales/I18n";

export default {
	trans(key, defaultVal, value) {
		let result;

		if(defaultVal != null && typeof(defaultVal) === "string") {
			result = i18n.t(key, value);
		}else if(defaultVal != null && typeof(defaultVal) !== "string") {
			result = i18n.t(key, defaultVal);
		}else{
			result = i18n.t(key);
		}

		// json 파일에 key 없을 시, defaultValue 처리
		if(result === key) {
			result = defaultVal;
		}

		return result;
	},

	getLanguage() {
		return localStorage.getItem("defaultLanguage").substring(0, 2);
	},
}


// WEBPACK FOOTER //
// ./src/locales/I18nUtil.js